<div class="w-full flex justify-center" [ngSwitch]="component.ctaType">
    <app-apply-button
        *ngSwitchCase="'apply'"
        [job]="job"
        [component]="component"
        [buttonConfig]="component.buttonConfig"></app-apply-button>
    <button
        class="inline-flex items-center justify-center"
        [ngStyle]="buttonStyle"
        *ngSwitchCase="'refer'"
        (click)="onClick()"
        [ngClass]="buttonClasses">
        <span class="mat-icon" *ngIf="component.buttonConfig?.icon">{{ component.buttonConfig.icon }}</span>
        <span>{{ component.buttonText }}</span>
    </button>
    <button
        class="inline-flex items-center justify-center"
        [ngStyle]="buttonStyle"
        *ngSwitchCase="'lead'"
        (click)="onClick()"
        [ngClass]="buttonClasses">
        <span class="mat-icon" *ngIf="component.buttonConfig?.icon">{{ component.buttonConfig.icon }}</span>
        <span>{{ component.buttonText }}</span>
    </button>
    <button
        class="inline-flex items-center justify-center"
        [ngStyle]="buttonStyle"
        *ngSwitchCase="'row'"
        (click)="onClick()"
        [ngClass]="buttonClasses">
        <span class="mat-icon" *ngIf="component.buttonConfig?.icon">{{ component.buttonConfig.icon }}</span>
        <span>{{ component.buttonText }}</span>
    </button>
    <a
        class="inline-flex items-center justify-center"
        [ngStyle]="buttonStyle"
        *ngSwitchCase="'url'"
        [href]="component.url"
        target="_blank"
        [ngClass]="buttonClasses">
        <span class="mat-icon" *ngIf="component.buttonConfig?.icon">{{ component.buttonConfig.icon }}</span>
        <span>{{ component.buttonText }}</span>
    </a>
</div>
